import BaseAPI from '@/apis/base/baseApi';

export default class BudgetApi extends BaseAPI {
  apiName = 'FA';
}
